import FavoritePresenter from 'lib/Presenters/FavoritePresenter';
import { useSelector } from 'react-redux';
import State from 'types/State';

export default function useFavorites(): {
  favorites: FavoritePresenter[];
} {
  const favoritesByVin = useSelector((state: State) => state.favorites.byVin);
  const favoriteData = useSelector((state: State) =>
    state.favorites.allVins.map((vin) => state.favorites.byVin[vin])
  );

  const leadsData = useSelector((state: State) => state.leads.leads);

  const contactedFavorites = leadsData.filter((lead) => favoritesByVin[lead.vin]);

  const favorites = favoriteData.map(
    (f) =>
      new FavoritePresenter(
        f,
        contactedFavorites.find((contactedFavorite) => contactedFavorite.vin === f.vin)
      )
  );

  return { favorites };
}
